import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import {
    DepositLimitsLink,
    RemainingLimitWrapper,
} from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/remainingLimit/RemainingLimit.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';

interface RemainingLimitType {
    isSignup: boolean;
    languagesState: LanguagesState;
    value: string;
}

export const RemainingLimit = observer('RemainingLimit', ({ isSignup, languagesState, value }: RemainingLimitType) => {
    return (
        <RemainingLimitWrapper data-test='remaining-deposit-limit'>
            <span>
                {languagesState.translateTokens(
                    languagesState.getTranslation('account.top-up.remaining-limits', 'Remaining [link]'),
                    () => {
                        return (
                            <DepositLimitsLink
                                key='limits'
                                to={{ account: 'limits' }}
                                dataTest='deposit-limit'
                                isSignup={isSignup}
                            >
                                <I18n
                                    langKey='account.top-up.remaining-limits.link'
                                    defaultText='Deposit Limit:'
                                />
                            </DepositLimitsLink>
                        );
                    }
                )}
            </span>
            {value}
        </RemainingLimitWrapper>
    );
});
